import { format } from "date-fns";

import { getDateFormat } from "@/lib/utils";

type RecentHotelStay = {
  checkin: string;
  checkout: string;
};

export function getValidRecentHotelStayDates(
  stay: RecentHotelStay,
  now: Date = new Date()
): RecentHotelStay {
  const today = new Date(now);
  today.setHours(0, 0, 0, 0);
  let checkin = getDateFormat(stay.checkin);
  let checkout = getDateFormat(stay.checkout);

  if (
    Number.isNaN(checkin.getTime()) ||
    Number.isNaN(checkout.getTime()) ||
    checkin < today ||
    checkout <= checkin
  ) {
    checkin = today;
    checkout = new Date(today);
    checkout.setDate(checkout.getDate() + 1);
  }

  return {
    checkin: format(checkin, "yyyy-MM-dd"),
    checkout: format(checkout, "yyyy-MM-dd"),
  };
}
